/**
 * Accordion — Seção colapsável com animação suave
 */
import type { JSX } from 'preact';
import { useState } from 'preact/hooks';
import { T } from '../../styles/tokens';

interface AccordionProps {
  title: string;
  defaultOpen?: boolean;
  children: any;
  icon?: any;
  badge?: string | number;
  style?: JSX.CSSProperties;
}

export function Accordion({ title, defaultOpen = false, children, icon, badge, style }: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div style={{
      borderBottom: `1px solid ${T.border}`,
      ...style,
    }}>
      {/* Cabeçalho clicável */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: T.space3,
          padding: `${T.space4}px 0`,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: T.text,
          fontSize: T.textMd,
          fontWeight: T.weightSemibold,
          textAlign: 'left',
        }}
      >
        {/* Chevron */}
        <svg
          width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2"
          style={{
            transition: `transform ${T.transitionNormal}`,
            transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
            flexShrink: 0,
            color: T.textMuted,
          }}
        >
          <path d="M9 18l6-6-6-6" />
        </svg>

        {icon && <span style={{ flexShrink: 0 }}>{icon}</span>}
        <span style={{ flex: 1 }}>{title}</span>
        {badge != null && (
          <span style={{
            background: T.bgCardHover,
            color: T.textSecondary,
            fontSize: T.textXs,
            fontWeight: T.weightBold,
            borderRadius: T.radiusFull,
            padding: '2px 8px',
          }}>
            {badge}
          </span>
        )}
      </button>

      {/* Conteúdo colapsável */}
      <div style={{
        overflow: 'hidden',
        maxHeight: open ? 2000 : 0,
        transition: `max-height ${T.transitionSlow}`,
        opacity: open ? 1 : 0,
      }}>
        <div style={{ paddingBottom: T.space4 }}>
          {children}
        </div>
      </div>
    </div>
  );
}
